import * as React from "react";
import Button from "@material-ui/core/Button";

var Togglable = function Togglable(_a) {
  var initiallyVisible = _a.initiallyVisible,
      hideButtonText = _a.hideButtonText,
      displayButtonText = _a.displayButtonText,
      children = _a.children;

  var _b = React.useState(initiallyVisible),
      toggled = _b[0],
      setToggled = _b[1];

  var toggle = function toggle() {
    return setToggled(!toggled);
  };

  return React.createElement(React.Fragment, null, React.createElement(Button, {
    variant: "outlined",
    color: "default",
    onClick: toggle
  }, toggled ? hideButtonText : displayButtonText), toggled && children);
};

export default Togglable;